import {create} from "zustand";

export const useLogoStore = create((set) => ({
  logo: "Data Explorer",
  setLogo: (logo) => set({logo}),
}));
